import Tabs from '../components/Tabs';

export default class StaticProductTabs {
  constructor(section) {
    this.section = section;

    this.productImages = new Tabs(this.section.el);
  }
}
